import { Component, ElementRef, Input, OnInit, ViewChild } from "@angular/core";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import moment from "moment";
import { FirestoreService } from "src/app/services/firestore.service";
import { UtilService } from "src/app/services/util.service";
import Swal from "sweetalert2";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import html2canvas from "html2canvas";
import { FormControl,FormGroup, Validators } from "@angular/forms";

@Component({
  selector: "app-modal-popups",
  templateUrl: "./modal-popups.component.html",
  styleUrls: ["./modal-popups.component.scss"],
})
export class ModalPopupsComponent implements OnInit {
  lastMaintenance: any;
  @ViewChild("vm", { static: false }) vm: ElementRef<HTMLElement>;
  @ViewChild("check", { static: false }) check: ElementRef<HTMLElement>;
  @ViewChild("cbm", { static: false }) cbm: ElementRef<HTMLElement>;
  @ViewChild("tbm", { static: false }) tbm: ElementRef<HTMLElement>;
  @ViewChild("pm", { static: false }) pm: ElementRef<HTMLElement>;
  @ViewChild("pictorialImg", { static: false }) pictorialImg: any;
  headerList = [
    { columnName: "Activities", columnId: "activityName" },
    { columnName: "Frequency", columnId: "frequency" },
    { columnName: "Last Maintenance", columnId: "lastMaintenanceDate" },
    { columnName: "Next Maintenance", columnId: "nextMaintenanceDate" },
  ];
  tbmheaderList = [
    { columnName: "Activities", columnId: "activityName" },
    { columnName: "Frequency In Months", columnId: "frequencyInMonths" },
    { columnName: "Planned Date", columnId: "plannedDate" },
    { columnName: "Actual Done", columnId: "lastMaintenanceDate" },
  ];
  pmheaderList = [
    { columnName: "Activities", columnId: "activityName" },
    { columnName: "Frequency In Months", columnId: "frequency" },
    { columnName: "Planned Date", columnId: "plannedDate" },
    { columnName: "Completion Date", columnId: "lastMaintenanceDate" },
  ];
  commentForm=new FormGroup({
    comments:new FormControl('',[Validators.required])
  })
  checklist: any;
  equipmentList: any = [];
  pathArray: any[] = [];
  equipmentPath: any = "";
  @Input() screen: string;
  predictiveList: any[];
  activeField: any = {};
  editActivity: any;
  @Input("values")
  set in(val: any) {
    if (val.type == "breakdown") {
      this.lastMaintenance = val.data;
      this.getEquipments();
      setTimeout(() => {
        let el: HTMLElement = this.vm.nativeElement;
        el.click();
      }, 10);
    } else if (val.type == "checklist") {
      this.checklist = val.data;
      setTimeout(() => {
        let el: HTMLElement = this.check.nativeElement;
        el.click();
      }, 10);
    } else if (val.type == "cbm" || val.type == "tbm" ||val.type=='pm') {
      this.predictiveList = val.data;
      this.predictiveList.forEach((c, index) => {
        this.activeField[index] = true;
      });
      if (val.type == "cbm") {
        setTimeout(() => {
          let el: HTMLElement = this.cbm.nativeElement;
          el.click();
        }, 10);
      } else  if(val.type == "tbm"){
        setTimeout(() => {
          let el: HTMLElement = this.tbm.nativeElement;
          el.click();
        }, 10);
      }
      else{
        setTimeout(() => {
          let el: HTMLElement = this.pm.nativeElement;
          el.click();
        }, 10);
      }
    } else if (val.type == "equipment") {
      this.lastMaintenance = val.data;
      this.getEquipments();
      setTimeout(() => {
        let el: HTMLElement = this.vm.nativeElement;
        el.click();
      }, 10);
    }
  }
  getEquipments() {
    let params = {
      category: "EQUIPMENTS",
      conditions: [
        {
          key: "asset",
          symbol: "==",
          value: this.lastMaintenance.asset,
        },
        {
          key: "agency",
          symbol: "==",
          value: this.lastMaintenance.agency,
        },
      ],
    };
    this.fs.getData(params).subscribe((data: any) => {
      if (data.status == "success") {
        this.equipmentList = data.data;
        this.pathArray.unshift(this.lastMaintenance.equipmentName);
        if (this.lastMaintenance.parentId != this.lastMaintenance.asset) {
          this.findParentPath(this.lastMaintenance.parentId);
        } else {
          this.makePathString();
        }
      }
    });
  }
  findParentPath(parentId) {
    let parent = this.equipmentList.filter((e) => {
      return parentId == e.equipmentId;
    });
    this.pathArray.unshift(parent[0].equipmentName);
    if (parent[0].parentId == parent[0].asset) {
      this.makePathString();
    } else {
      this.findParentPath(parent[0].parentId);
    }
  }
  makePathString() {
    this.pathArray.forEach((s, index) => {
      let seperator = index != this.pathArray.length - 1 ? " > " : "";
      this.equipmentPath += `${s}${seperator}`;
    });
  }
  tpeOf(value) {
    return typeof value;
  }
  comments;
  constructor(
    private modalService: NgbModal,
    private fs: FirestoreService,
    private util: UtilService
  ) {}
  ngOnInit(): void {}
  formatDate(date) {
    if (date) {
      if (typeof date == "string") {
        date = moment(date).format("DD-MMM-YYYY");
      } else if (typeof date == "object") {
        if (date._seconds) {
          date = moment(date._seconds * 1000).format("DD-MMM-YYYY");
        } else if(date.seconds) {
          date = moment(date.seconds * 1000).format("DD-MMM-YYYY");
        } else {
          date = moment(date).format("DD-MMM-YYYY");
        }
      } else {
        date = moment(date).format("DD-MMM-YYYY");
      }
    }
    return date ? date : "";
  }
  formatSpecification(data) {
    return this.util.formatSpecification(data);
  }
  open(content) {
    let modalOptions = { size: "lg" };
    this.modalService.open(content, modalOptions).result.then(
      (result) => {
        //this.closeResult = `Closed with: ${result}`;
      },
      (reason) => {
        //this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
      }
    );
  }
  deleteComments(){

  }
  editcomments(data){
    this.commentForm.controls['comments'].setValue(data.comment)

  }
  addComents() {
    let collectionName;
    let collectionName2;
    if (this.screen && this.screen == "equipments") {
      collectionName = "EQUIPMENTS";
      collectionName2 = "MAINTENANCE";
    } else if (this.screen && this.screen == "maintenance") {
      collectionName = "MAINTENANCE";
      collectionName2 = "EQUIPMENTS";
    }
    if (this.comments && this.comments != "") {
      let id = this.lastMaintenance.id;
      //delete this.lastMaintenance.id;
      this.lastMaintenance.comments = this.lastMaintenance.comments
        ? this.lastMaintenance.comments
        : [];
      let obj = {
        comment: this.comments,
        timestamp: moment().toDate(),
        commentsBy: localStorage.getItem("email"),
      };
      this.lastMaintenance.comments.push(obj);
      this.fs
        .fireStoreDocUpdate(collectionName, id, this.lastMaintenance)
        .subscribe((response: any) => {
          if (response.status == "success") {
            this.saveMaintenance(collectionName2);
          } else {
            this.util.showSnakbarMessage(
              "error",
              "Comments Added Failed.",
              "end",
              "top"
            );
          }
        });
    }
  }
  saveMaintenance(collection) {
    let params = {
      category: collection,
      conditions: [
        {
          key: "equipmentId",
          symbol: "==",
          value: this.lastMaintenance.equipmentId,
        },
      ],
    };
    if (collection == "MAINTENANCE") {
      if (typeof this.lastMaintenance.maintenanceDate == "string") {
        this.lastMaintenance.maintenanceDate = moment(
          this.lastMaintenance.maintenanceDate
        ).toDate();
      } else {
        this.lastMaintenance.maintenanceDate = moment(
          this.lastMaintenance.maintenanceDate._seconds * 1000
        ).toDate();
      }
      params.conditions.push({
        key: "maintenanceDate",
        symbol: "==",
        value: this.lastMaintenance.maintenanceDate,
      });
    }
    this.fs.getData(params).subscribe((data: any) => {
      if (data.status == "success" && data.data.length) {
        let lastMaintenance = data.data[0];
        if (this.comments && this.comments != "") {
          let id = lastMaintenance.id;
          delete lastMaintenance.id;
          lastMaintenance.comments = lastMaintenance.comments
            ? lastMaintenance.comments
            : [];
          let obj = {
            comment: this.comments,
            timestamp: moment().toDate(),
            commentsBy: localStorage.getItem("email"),
          };
          lastMaintenance.comments.push(obj);
          this.fs
            .fireStoreDocUpdate(collection, id, lastMaintenance)
            .subscribe((response: any) => {
              if (response.status == "success") {
                this.util.showSnakbarMessage(
                  "success",
                  "Comments Added successfully..",
                  "end",
                  "top"
                );
                this.comments = "";
              } else {
                this.util.showSnakbarMessage(
                  "error",
                  "Comments Added Failed.",
                  "end",
                  "top"
                );
              }
            });
        }
      }
    });
  }
  toggleFunc(i: any) {
    this.activeField[i] = !this.activeField[i];
    // this.activeField = i == this.activeField ? null : i
  }

  predictiveMaintenanceDelete(data: any, index: number) {
    Swal.fire({
      title: "Do you want to delete the maintenance record?",
      showDenyButton: true,
      showCancelButton: false,
      confirmButtonText: `Delete`,
      denyButtonText: `Cancel`,
    }).then((result) => {
      if (result.isConfirmed) {
        data.maintenanceHistory.splice(index, 1);
        this.fs
          .fireStoreDocUpdate("CBM", data.id, {
            maintenanceHistory: data.maintenanceHistory,
          })
          .subscribe(
            (response: any) => {
              if (response.status == "success") {
                this.util.showSnakbarMessage(
                  "success",
                  "Maintenance Record Deleted Successfully!",
                  "end",
                  "top"
                );
              } else {
                this.util.showSnakbarMessage(
                  "error",
                  response.message,
                  "end",
                  "top"
                );
              }
            },
            (err) => {
              console.error(err);
              this.util.showSnakbarMessage(
                "error",
                "Maintenance Record Deletion failed",
                "end",
                "top"
              );
            }
          );
      } else if (result.isDenied) {
      }
    });
  }
  checkDataType(data) {
    let type = typeof data;
    if (type == "string") {
      return data;
    } else {
      if (data.value == "Range (Min - Max)") {
        return `${data.min} - ${data.max} ${data.unit}`;
      } else if (data.value == "Lesserthan (<)") {
        return `< ${data.thresh_value} ${data.unit}`;
      } else if (data.value == "Greaterthan (>)") {
        return `> ${data.thresh_value} ${data.unit}`;
      } else if (data.value == "Equals (=)") {
        return `Equal to ${data.thresh_value} ${data.unit}`;
      } else if (data.value == "Min") {
        return `Min ${data.thresh_value} ${data.unit}`;
      } else if (data.value == "Max") {
        return `Max ${data.thresh_value} ${data.unit}`;
      } else if (data.value == "Text") {
        return `${data.thresh_value}`;
      }
      return data.value;
    }
  }
  formatData(data) {
    let obj = { specificationType: data.value };
    if (data.value == "Range (Min - Max)") {
      obj["min_value"] = data.min;
      obj["max_value"] = data.max;
    } else {
      obj["threshold_value"] = data.thresh_value;
    }
    obj["unit"] = data.unit;
    return this.util.formatSpecification(obj);
  }
  formatDefects(defects, type) {
    if (type == "onImage") {
      let codes = "";
      if (Object.keys(defects).length) {
        for (let key in defects) {
          codes += key + ", ";
        }
      }
      return codes;
    } else {
      let codes = "";
      if (Object.keys(defects).length) {
        for (let key in defects) {
          codes += `${key} - ${defects[key].count}, `;
        }
      }
      return codes;
    }
  }
  checkObjLen(ob) {
    return Object.keys(ob).length;
  }
  async convertHtmltoImage(element) {
    return new Promise((resolve, reject) => {
      try {
        html2canvas(element, {
          allowTaint: true,
          useCORS: true,
        }).then((canvas) => {
          resolve({ status: "success", content: canvas });
        });
      } catch (err: any) {
        resolve({ status: "failure", message: err.toString() });
      }
    });
  }
  // this.convertHtmltoImage(pdf).then((report: any) => {
  //   var imgWidth = 210;
  //   var pageHeight = 295;
  //   var imgHeight =
  //     (report.content.height * imgWidth) / report.content.width;
  //   var heightLeft = imgHeight;
  //   var imgData = report.content.toDataURL("image/png");
  //   var doc: jsPDF = new jsPDF("p", "mm");
  //   var position = 0;
  //   doc.addImage(imgData, "PNG", 0, 30, imgWidth, imgHeight);
  //   heightLeft -= pageHeight;
  //   doc.text(`Total Defects: ${this.totalDefects}`,15,imgHeight+33)
  //   autoTable(doc, ({
  //     body: this.defectData['defectData'],
  //     columns: [
  //       { header: 'Defect Name', dataKey: 'name' },
  //       { header: 'No of Defects', dataKey: 'count' },
  //       { header: 'Percentage (%)', dataKey: 'y' },

  //     ],
  //     pageBreak:'auto',
  //     startY:imgHeight +35
  //   }));
  //   doc.save("Defects_Report" + moment().format("DD-MM-YYYY HH:mm:ss") + ".pdf");
  // });
  async downloadData(docId:any) {
    var doc = new jsPDF("l", "mm",'a4');
    const pageWidth = doc.internal.pageSize.getWidth(); //210
    const pageHeight = doc.internal.pageSize.getHeight(); //297
    // let img :any= new Image()
    // img.src = '../../../../assets/images/vecvlogo.png'
    // doc.addImage(img,'png',15,2,15,15);
    let y = 10;
    const details = document.getElementById("details");
    let titleWidth = doc.getTextWidth(this.checklist.checklist_name);
    let titleXPosistion = pageWidth / 2 - titleWidth / 2;
    doc.text(this.checklist.checklist_name, titleXPosistion, y);
    y = y + 13;
    doc.setFontSize(10);
    doc.text(
      `Date: ${this.formatDate(this.checklist.maintenanceDate)}`,
      15,
      y,
      { align: "left" }
    );
    y = y + 5;
    doc.text(`Category: ${this.checklist.category}`, 15, y, { align: "left" });
    y = y + 5;
    doc.text(`Frequency: ${this.checklist.frequency}`, 15, y, {
      align: "left",
    });
    y = y + 5;
    doc.text(`Done by: ${this.checklist.email}`, 15, y, { align: "left" });
    let y2 = 23;
    this.checklist.metaData.forEach((d) => {
      let splitTitle = doc.splitTextToSize(`${d.columnName}: ${d.value}`, 50);
      doc.text(splitTitle, pageWidth - 55, y2, {
        align: "left",
      });
      y2 = y2 + 5;
    });
    if (y2 > y) {
      y = y2 + 2;
    } else {
      y = y + 2;
    }
    doc.line(15, y, pageWidth - 15, y);
    y = y + 5;
    if (this.checklist.view_type && this.checklist.view_type == "pictorial") {
      let img = document.getElementById("pictorialImg");
      if (img.innerHTML) {
        this.convertHtmltoImage(img).then((report: any) => {
          let imgWidth = pageWidth;
          let imgHeight =
            (report.content.height * imgWidth) / report.content.width;
          let heightLeft = imgHeight;
          let imgData = report.content.toDataURL("image/png");
          let imgStartX = pageWidth / 2 - imgWidth / 2;
          doc.addImage(imgData, "PNG", imgStartX, y, imgWidth, imgHeight);
          y = y + imgHeight + 10;
          this.printPdf(doc, y, "header");
        });
      }
    } else if (
      this.checklist.view_type &&
      this.checklist.view_type == "defect_sheet"
    ) {
      let img = document.getElementById("defectImg");
      if (img.innerHTML) {
        this.convertHtmltoImage(img).then((report: any) => {
          let imgWidth = pageWidth;
          let imgHeight =
            (report.content.height * imgWidth) / report.content.width;
          let heightLeft = imgHeight;
          let imgData = report.content.toDataURL("image/png");
          let imgStartX = pageWidth / 2 - imgWidth / 2;
          let table = document.getElementById("defectTable");
          if (table) {
            autoTable(doc, {
              html: `#defectTable`,
              startY: y,
              margin: 0,
              pageBreak: "auto",
            });
          y = doc.previousAutoTable.finalY + 10;
          }
          doc.addPage()
          doc.addImage(imgData, "PNG", imgStartX, 10, imgWidth, imgHeight);
          y = y + imgHeight + 10;
          doc.save(
            this.checklist.checklist_name +
              " " +
              moment().format("DD-MM-YYYY HH:mm:ss") +
              ".pdf"
          );
        });
      }
    } else {
      this.printPdf(doc, y, "header");
    }
  }
  printPdf(doc, y, id) {
    let table = document.getElementById(id);
    if (table) {
      autoTable(doc, {
        html: `#${id}`,
        startY: y,
        margin: 0,
        pageBreak: "auto",
      });
    }
    doc.save(
      this.checklist.checklist_name +
        " " +
        moment().format("DD-MM-YYYY HH:mm:ss") +
        ".pdf"
    );
  }
}
